import { createFileRoute } from "@tanstack/react-router";

import { WorkflowSetupPage } from "../components/workflows/WorkflowSetupPage";

export type WorkflowDetailSearch = { readonly tab?: "overview" | "edit" };

export const Route = createFileRoute("/workflows/$id")({
  validateSearch: (raw: Record<string, unknown>): WorkflowDetailSearch =>
    raw.tab === "edit" ? { tab: "edit" } : {},
  component: WorkflowSetupPage,
});
